<template>
  <div v-if="activeModals.length">
    <BaseDialogModal
      v-for="(modal,index) in activeModals"
      v-bind="modal"
      :key="'dialog-modal-'+index"
      @close-modal="handleClose(index)"
    />
  </div>
</template>

<script setup lang="ts">
import { BaseDialogModal } from '@/components/Base';
import { onBeforeUnmount, ref } from 'vue';
import { useCustomEvent } from '@/composables';
import type { IBaseDialogModal } from '@/types/components';
const activeModals = ref<IBaseDialogModal[]>([]);

const { catchEvent } = useCustomEvent();
catchEvent('GlobalEvent_PushModal', modalHandler, false);
function handleClose(index: number) {
  activeModals.value.splice(index, 1);
}
function modalHandler(event: CustomEvent) {
  const data = event.detail as IBaseDialogModal;
  if (data) {
    activeModals.value.push(data);
  }
}
onBeforeUnmount(() => {
  catchEvent('GlobalEvent_PushModal', modalHandler, true);
});

</script>